import { useQuery } from '@tanstack/react-query';
import { FeaturesApi } from '../../../apis/FeaturesApi/FeaturesApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';

export function useVisibleFeatures(facilityId?: number, enabled: boolean = true) {
    return useQuery<string[]>({
        queryKey: [QueryKeys.visibleFeatures, facilityId],
        queryFn: () => FeaturesApi.getVisibleFeatures(facilityId),
        enabled,
    });
}
